import { render } from "./retouch.vue?vue&type=template&id=d878cc96"
import script from "./retouch.vue?vue&type=script&lang=js"
export * from "./retouch.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__